// hero-video.js - 稳定版：封面层兜底，视频准备好后再淡入
(function () {
  function initHeroVideos() {
    document.querySelectorAll('video[id^="Mp4Video-"]').forEach((video) => {
      const section = video.closest('.video-parent-section');
      const wrapper = video.closest('.video-wrapper');
      const posterLayer = wrapper ? wrapper.querySelector('.hero-video-poster') : null;

      if (!section || !wrapper) return;

      const poster480p = video.dataset.poster480p || "";
      const poster720p = video.dataset.poster720p || "";
      const posterOriginal = video.dataset.posterOriginal || "";

      function choosePoster() {
        const width = window.innerWidth;

        if (width <= 480 && poster480p) return poster480p;
        if (width <= 768 && poster720p) return poster720p;

        return posterOriginal || poster720p || poster480p || "";
      }

      function setPoster() {
        const poster = choosePoster();

        if (poster) {
          if (video.poster !== poster) {
            video.poster = poster;
          }

          if (posterLayer) {
            posterLayer.style.backgroundImage = `url("${poster}")`;
          }
        }
      }

      function markLoaded() {
        if (!section.classList.contains("video-loaded")) {
          section.classList.add("video-loaded");
          section.classList.add("loaded");
        }
      }

      setPoster();
      window.addEventListener("resize", setPoster);

      // 更早拿到首帧时就准备显示
      video.addEventListener("loadeddata", markLoaded, { once: true });
      video.addEventListener("canplay", markLoaded, { once: true });

      // 真正播放时可移除原生 poster，视觉由 video 接管
      video.addEventListener(
        "playing",
        () => {
          video.removeAttribute("poster");
        },
        { once: true }
      );

      // 尝试播放，兼容部分移动端自动播放策略
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => {
          // 自动播放失败时，不强制显示空 video，保留封面层
        });
      }

      // fallback：如果很久都没 ready，也不要黑屏，只保留封面
      setTimeout(() => {
        if (!section.classList.contains("video-loaded")) {
          setPoster();
        }
      }, 5000);
    });
  }

  if (document.readyState !== "loading") {
    initHeroVideos();
  } else {
    document.addEventListener("DOMContentLoaded", initHeroVideos);
  }
})();